export default "__VITE_ASSET__CZBqXtvj__"